import type { EnvironmentEnum } from '@platform2-lib/types';

const mode = import.meta.env.MODE as EnvironmentEnum;

// The name of the release, e.g. 'dev-new-feature' or 'v6.4.0'
const release =
  (import.meta.env.VITE_GITHUB_REF_NAME as string | undefined) ?? '';

const host =
  mode === 'production'
    ? 'api.globalwebindex.com'
    : `api-${mode}.globalwebindex.com`;
const origin = `https://${host}`;

export default {
  api: {
    host,
    origin,
    version: 'v1',
    crosstabs: `${origin}/platform/v1/crosstabs/`,
    query: `${origin}/v2/query/`
  },
  breakpoints: {
    xSmall: 320,
    small: 430,
    medium: 768,
    large: 1024,
    xLarge: 1440,
    xxLarge: 1920
  },
  chat: {
    crosstab: {
      minInsights: 5
    },
    sessions: {
      maxSize: 40
    },
    sources: {
      audiences: {
        visibilitySize: 4
      },
      topics: {
        visibilitySize: 4
      }
    }
  },
  chart: {
    regular: {
      width: 268,
      height: 147
    },
    compact: {
      breakpoint: 636,
      width: 280,
      height: 120
    },
    row: {
      defaultHeight: 28,
      maxHeight: 36
    },
    imageExport: {
      regular: {
        width: 589
      },
      compact: {
        width: 430
      }
    }
  },
  defaultDataset: {
    id: 'ds-core',
    title: 'GWI Core'
  },
  env: mode,
  hrefs: {
    dataCoverage: 'https://www.gwi.com/data-coverage'
  },
  prompt: {
    audiences: {
      maxSize: 3,
      input: {
        maxLength: 80
      },
      selected: {
        maxSize: 5
      },
      title: {
        maxLength: 34
      }
    },
    error: {
      maxCount: 3
    },
    examples: {
      size: 4
    },
    textArea: {
      maxLines: 6
    },
    menu: {
      maxHeight: 248
    }
  },
  release
};
